module.exports = __webpack_public_path__ + "app-static/img/08.b7761c4d.jpg";